import React from 'react';
import { Outlet } from 'react-router-dom';
import styles from './PublicLayout.module.scss';
import Footer from '../footer/Footer';
import Header from '../header/Header';

const PublicLayout: React.FC = () => {
    return (
        <div className={styles.layout}>
            <Header />
            <main className={styles.content}>
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default PublicLayout;
